import { render } from "./CasinoAggregatorSolution.vue?vue&type=template&id=bc5c221e&scoped=true"
import script from "./CasinoAggregatorSolution.vue?vue&type=script&lang=js"
export * from "./CasinoAggregatorSolution.vue?vue&type=script&lang=js"

import "./CasinoAggregatorSolution.vue?vue&type=style&index=0&id=bc5c221e&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5c221e"]])

export default __exports__